document.addEventListener('click', (event) => {
  if (!event.target.closest('[data-tabbar-cart]')) return;
  const drawer = document.querySelector('cart-drawer');
  if (drawer) drawer.open(event.target.closest('[data-tabbar-cart]'));
  else window.location.href = (window.routes?.cart_url) ?? '/cart';
});

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
    const badge = document.querySelector('[data-tabbar-count]');
    if (!badge) return;
    try {
      const cart = await fetch(`${window.routes?.cart_url ?? '/cart'}.js`).then((r) => r.json());
      badge.textContent = cart.item_count;
      badge.hidden = cart.item_count === 0;
    } catch { /* el contador se corrige en la siguiente carga */ }
  });
}
